<template>
  <div class="mt-4">
    <v-card-title class="d-flex justify-center mt-n5">
      <v-spacer />
      گزارش سفارش شماره :
      <span class="blue--text">
        {{
          forResponseData && forResponseData.tradeNumber
            ? ' ' + forResponseData.tradeNumber + ' '
            : ''
        }}
      </span>
      <v-spacer />

      نام کسب و کار :
      <span class="blue--text">
        {{ propData && propData.merchantName ? propData.merchantName : '' }}
      </span>
      <v-spacer />

      به تاریخ :
      <span class="red--text">
        {{
          forResponseData && forResponseData.createdTimeUtc
            ? ' ' + jalaliDate(forResponseData.createdTimeUtc) + ' '
            : ''
        }}
      </span>
      <v-spacer />
    </v-card-title>
    <v-sheet outlined color="blue">
      <v-card outlined elevation="0" class="pa-5">
        <v-row>
          <v-col cols="6" sm="4" md="3">
            <label>موضوع سفارش:</label>
            <strong>
              {{
                propData && propData.requestDisplayName
                  ? propData.requestDisplayName
                  : ''
              }}
            </strong>
          </v-col>
          <v-col cols="6" sm="4" md="3">
            <label>دسته سفارش:</label>
            <strong>
              {{
                propData && propData.categoryDisplayName
                  ? propData.categoryDisplayName
                  : ''
              }}
            </strong>
          </v-col>
          <!-- <v-col cols="6" sm="4" md="3">
          <label> روش پرداخت:</label>
          <strong
            >{{
              reportData && reportData.paymentMethod
                ? paymentMethodDisplayName(reportData.paymentMethod)
                : ''
            }}
          </strong>
        </v-col> -->
          <v-col cols="6" sm="4" md="3">
            <label>
              مهلت شرکت در
              {{
                propData && propData.requestDisplayName
                  ? propData.requestDisplayName
                  : ''
              }}:
            </label>
            <strong
              >{{
                propData && propData.bidExpirationTimeInDays
                  ? propData.bidExpirationTimeInDays
                  : ''
              }}
              روز ({{
                propData &&
                propData.bidExpirationTimeInDaysFromNow &&
                propData.bidExpirationTimeInDaysFromNow != 0
                  ? propData.bidExpirationTimeInDaysFromNow + 'روز باقی مانده'
                  : 'منقضی شده'
              }})
            </strong>
          </v-col>
          <v-col
            cols="6"
            sm="4"
            md="3"
            v-if="propData && propData.request == 'ContractorRecognition'"
          >
            <label> مدت زمان اجرای طرح : </label>
            <strong
              >{{
                propData && propData.runningDuration
                  ? propData.runningDuration
                  : 0
              }}
              ماه
            </strong>
          </v-col>
          <v-col cols="6" sm="4" md="3">
            <label> نام کسب و کار: </label>
            <strong>{{
              propData && propData.merchantName ? propData.merchantName : ''
            }}</strong>
          </v-col>
          <v-col cols="6" sm="4" md="3">
            <label> وضعیت سفارش: </label>
            <strong>{{
              propData && propData.statusDisplayName
                ? propData.statusDisplayName
                : ''
            }}</strong>
          </v-col>
          <v-col
            v-if="responseData && responseData.responseStatus"
            cols="6"
            sm="4"
            md="3"
          >
            <label> وضعیت پاسخ: </label>
            <strong>{{
              responseData && responseData.responseStatus
                ? responseData.responseStatus
                : ''
            }}</strong>
          </v-col>
          <v-col cols="6" sm="4" md="3">
            <label> تاریخ ایجاد:</label>
            <strong>{{
              propData && propData.createdTimeUtc
                ? jalaliDate(propData.createdTimeUtc)
                : ''
            }}</strong>
          </v-col>
          <v-col
            v-if="responseData && responseData.ownerUserFullName"
            cols="6"
            sm="4"
            md="3"
          >
            <label> نام مسئول:</label>
            <strong>{{
              responseData && responseData.ownerUserFullName
                ? responseData.ownerUserFullName
                : ''
            }}</strong>
          </v-col>
          <v-col
            cols="6"
            sm="4"
            md="3"
            v-if="propData && propData.request != 'ContractorRecognition'"
          >
            <label> تعداد کل اقلام سفارش:</label>
            <strong>{{
              responseData && responseData.itemsCount
                ? responseData.itemsCount
                : ''
            }}</strong>
          </v-col>
          <v-col
            v-if="responseData && responseData.rejectCause"
            cols="6"
            sm="4"
            md="3"
          >
            <label> دلیل رد سفارش:</label>
            <strong>{{
              responseData && responseData.rejectCause
                ? responseData.rejectCause
                : ''
            }}</strong>
          </v-col>
          <v-col
            v-if="responseData && responseData.description"
            cols="6"
            sm="4"
            md="3"
          >
            <label> توضیحات پاسخ:</label>
            <strong>{{
              responseData && responseData.description
                ? responseData.description
                : ''
            }}</strong>
          </v-col>
        </v-row>
      </v-card>
    </v-sheet>
    <div v-if="responseData && responseData.items">
      <v-sheet
        class="mt-5"
        outlined
        v-for="(item, ind) in responseData.items"
        :key="ind"
        color="blue"
      >
        <v-card outlined elevation="0" class="pa-5">
          <v-row>
            <v-col
              cols="6"
              sm="4"
              md="3"
              v-if="propData && propData.request != 'ContractorRecognition'"
            >
              <label> موضوع:</label>
              <strong>{{ item && item.title ? item.title : '' }} </strong>
            </v-col>

            <v-col
              cols="6"
              sm="4"
              md="3"
              v-if="propData && propData.request != 'ContractorRecognition'"
            >
              <label> تعداد کل :</label>
              <strong
                >{{ item && item.totalAmount ? item.totalAmount : '' }}
                {{
                  item && item.measurementUnitTitle
                    ? item.measurementUnitTitle
                    : ''
                }}</strong
              >
            </v-col>
            <v-col
              cols="6"
              sm="4"
              md="3"
              v-if="propData && propData.request != 'ContractorRecognition'"
            >
              <label> قیمت واحد :</label>
              <strong
                >{{
                  item && item.price && item.price.amount
                    ? item.price.amount
                    : ''
                }}
                {{
                  item && item.price && item.price.title ? item.price.title : ''
                }}
              </strong>
            </v-col>

            <v-col
              cols="6"
              sm="4"
              md="3"
              v-if="propData && propData.request != 'ContractorRecognition'"
            >
              <label> جنس مواد اولیه :</label>
              <strong
                >{{
                  item && item.rawMaterialTitle
                    ? item.rawMaterialTitle
                    : 'وارد نشده'
                }}
              </strong>
            </v-col>
            <v-col
              cols="6"
              sm="4"
              md="3"
              v-if="propData && propData.request != 'ContractorRecognition'"
            >
              <label> تاریخ نیاز :</label>
              <strong
                >{{
                  jalaliDate(
                    item && item.requireDateUtc ? item.requireDateUtc : ''
                  )
                }}
              </strong>
            </v-col>
            <v-col cols="12">
              <v-sheet
                outlined
                class="pa-1 pa-6 mt-5"
                v-if="item.documents && item.documents.length"
              >
                <v-col cols="12">
                  <strong class="blue--text">فایل اطلاعات پیوست </strong>
                </v-col>
                <v-row>
                  <v-col
                    cols="6"
                    md="4"
                    v-for="(x, i) in item.documents"
                    :key="i"
                  >
                    <v-card>
                      <v-card-text>
                        <v-col cols="12">
                          <v-img
                            v-if="x.fileId && x.fileId.thumbnailFileUrl"
                            :src="x.fileId.thumbnailFileUrl"
                            width="100%"
                          />
                        </v-col>
                        <v-col cols="12">
                          <label> نوع فایل:</label>
                          <strong>{{ x.documentTypeTitle }}</strong>
                        </v-col>
                        <v-col cols="12">
                          <label> توضیحات:</label>
                          <strong>{{
                            x.description ? x.description : 'وارد نشده'
                          }}</strong>
                        </v-col>
                        <v-col cols="12">
                          <a
                            target="_blank"
                            :href="
                              x.fileId && x.fileId.fileUrl
                                ? x.fileId.fileUrl
                                : ''
                            "
                            >{{
                              x.fileId && x.fileId.fileUrl ? 'دانلود' : ''
                            }}</a
                          >
                        </v-col>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-sheet>
            </v-col>

            <v-col
              cols="12"
              v-if="propData && propData.request != 'ContractorRecognition'"
            >
              <label> توضیحات قلم :</label>
              <strong
                >{{ item.description ? item.description : 'وارد نشده' }}
              </strong>
            </v-col>
          </v-row>
        </v-card>
      </v-sheet>
      <div v-if="!succeedPayment">
        <div
          v-if="
            (membershipAndPrice && !membershipAndPrice.hasMembership) ||
            (membershipAndPrice &&
              membershipAndPrice.hasMembership &&
              membershipAndPrice.membershipDetails &&
              !membershipAndPrice.membershipDetails.isAvailable)
          "
          class="m-5"
        >
          <v-alert
            type="warning"
            v-model="alert"
            close-label="Close Alert"
            dismissible
          >
            <span
              >شما حق اشتراک فعالی ندارید که بتوانید از آن استفاده کنید.
            </span>
            <span>
              هزینه انتشار : {{ totalPrice.amount | priceSplitter }} ریال</span
            >
          </v-alert>
          <payment-step
            :getMembershipAndPrice="true"
            @getHasPayment="closePaymentStep"
            :totalPrice="totalPrice"
            :objectId="
              propData.tradeResponseId !== undefined
                ? propData.tradeResponseId
                : propData.id
            "
            :sourceType="
              membershipAndPrice.servicePriceDetails.paymentSourceType
            "
          ></payment-step>
        </div>
        <div v-else class="mt-3">
          <v-alert
            type="success"
            v-model="alert"
            close-label="Close Alert"
            dismissible
          >
            .شما دارای اشتراک فعال جهت استفاده از این خدمت هستید
          </v-alert>
        </div>
      </div>
      <div v-else>
        <div class="mt-3">
          <v-alert
            type="success"
            v-model="alert"
            close-label="Close Alert"
            dismissible
          >
            با موفقیت پرداخت شد.
          </v-alert>
        </div>
      </div>
    </div>
    <v-card-actions>
      <v-spacer />
      <v-btn color="primary" @click="navToEdit">ویرایش</v-btn>
      <v-btn
        color="success"
        @click="sendResponse"
        v-if="
          membershipAndPrice &&
          membershipAndPrice.hasMembership &&
          membershipAndPrice.membershipDetails &&
          membershipAndPrice.membershipDetails.isAvailable
        "
        >ارسال پاسخ</v-btn
      >
      <v-btn
        color="success"
        @click="goToNextStep()"
        v-else-if="succeed || succeedPayment"
        >ادامه</v-btn
      >

      <v-btn color="error" @click="$emit('reportFlag')">بستن</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
import Helper from '@/core/helpers';
const tradeResponseRepository = () => RepoFactory.get('tradeResponse');
import { RepoFactory } from '@/baseRepository/Factory';
import PaymentStep from '../../FinancialManagement/subscription/components/PaymentStep.vue';
export default {
  mixins: [asyncLoadMixin, reusableMethodsMixin],
  components: {
    PaymentStep,
  },
  created() {
    this.getDataById();
    this.getTradeRequestByIdForResponse();
    this.getTradeResponseMembershipAndPrice();
  },
  props: {
    propData: {
      type: Object,
      default: null,
    },
    selectedTrade: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      alert: true,
      forResponseData: null,
      responseData: null,
      stateIds: [],
      stateName: [],
      cityName: [],
      tradeRequestTypeList: [],
      tradeCategoriesList: [],
      tradePaymentMethodList: [],
      deliveryDurationTypeList: [],
      deliveryItemHeader: [
        {
          text: 'تعداد',
          value: 'amount',
        },
        {
          text: 'تاریخ',
          value: 'deliveryDateUtc',
        },
      ],
      membershipAndPrice: null,
      succeedPayment: false,
    };
  },
  computed: {
    currentRoute() {
      return this.$route.fullPath;
    },
    tradeBaseUrl() {
      return this.$store.getters.tradeBaseUrl;
    },
    prop() {
      return this.propData;
    },
    totalPrice() {
     // if (!this.membershipAndPrice.hasMembership) {
        return {
          amount: this.membershipAndPrice.servicePriceDetails.totalPrice,
          currency: 'IRR',
        };
      //} else return null;
    },
    merchantId() {
      return this.$store.getters.currentMerchant;
    },
    succeed() {
      return this.$route.query.succeed == 'true'
        ? true
        : this.$route.query.succeed == 'false'
        ? false
        : undefined;
    },
  },
  methods: {
    closePaymentStep() {
      this.succeedPayment = true;
    },
    getTradeResponseMembershipAndPrice() {
      const loader = this.$loading.show();
      tradeResponseRepository()
        .getTradeResponseMembershipAndPrice(
          this.propData.tradeResponseId !== undefined
            ? this.propData.tradeResponseId
            : this.propData.id,
          this.tradeBaseUrl,
          {
            MerchantId: this.merchantId,
          }
        )
        .then((res) => {
          this.membershipAndPrice = res.data;
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
    getDataById() {
      const loader = this.$loading.show();
      tradeResponseRepository()
        .getTradeResponseById(
          this.propData.tradeResponseId !== undefined
            ? this.propData.tradeResponseId
            : this.propData.id,
          this.tradeBaseUrl,
          { MerchantId: this.$store.getters.currentMerchant }
        )
        .then((res) => {
          this.responseData = res.data;
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
    getTradeRequestByIdForResponse() {
      const loader = this.$loading.show();
      tradeResponseRepository()
        .getTradeRequsetByIdForResponse(
          this.propData.tradeRequestId != undefined
            ? this.propData.tradeRequestId
            : this.selectedTrade.id,
          this.tradeBaseUrl,
          { MerchantId: this.$store.getters.currentMerchant }
        )
        .then((res) => {
          this.forResponseData = res.data;
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
    clearStore() {
      this.$store.commit('setTradeResponseMerchantNotificationId', null);
      this.$store.commit('setTradeResponseHasResponse', false);
      this.$store.commit('setTradeResponseSelectedForEdit', null);
      this.$store.commit('setTradeResponseIsEdit', false);
      this.$store.commit('setTradeResponseShowForm', false);
      this.$store.commit('setTradeResponseId', null);
    },
    sendResponse() {
      const loader = this.$loading.show();
      tradeResponseRepository()
        .submitResponse(
          this.propData.tradeResponseId !== undefined
            ? this.propData.tradeResponseId
            : this.propData.id,
          this.tradeBaseUrl,
          {
            MerchantId: this.$store.getters.currentMerchant,
          }
        )
        .then((res) => {
          this.$dialog.message.success(' با موفقیت ارسال شد. ', {
            position: 'top-left',
          });
          // this.getTradeRequestMerchantNotificationsBySupplier();
          loader.hide();
          this.goToNextStep();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        });
    },
    navToEdit() {
      const loader = this.$loading.show();
      tradeResponseRepository()
        .getTradeResponseById(
          this.propData.tradeResponseId
            ? this.propData.tradeResponseId
            : this.propData.id,
          this.tradeBaseUrl,
          {
            MerchantId: this.$store.getters.currentMerchant,
          }
        )
        .then((res) => {
          if (!this.$store.getters.tradeResponseIsEdit) {
            this.$store.commit('setTradeResponseSelectedItem', this.propData);
            this.$store.commit(
              'setTradeResponseHasResponse',
              this.propData.hasResponse
            );
            this.$store.commit(
              'setTradeResponseMerchantNotificationId',
              this.propData.id
            );
            this.$store.commit(
              'setTradeResponseId',
              this.propData.tradeResponseId
            );
            this.$store.commit('setTradeResponseSelectedForEdit', res.data);
            this.$store.commit('setTradeResponseIsEdit', true);
            this.$store.commit('setTradeResponseShowForm', true);
            this.$router.push({
              path: `/trade-response-info/${this.propData.tradeRequestId}`,
            });
          } else {
            this.$emit('reportFlag');
          }

          loader.hide();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        });
    },
    goToNextStep() {
      if (this.currentRoute != '/trade-response') {
        this.clearStore();
        this.$router.push({ path: '/trade-response' });
      } else {
        this.$emit('reportFlag');
        this.$emit('getData');
      }
      this.$router.push({ path: '/trade-response' });
    },
  },
};
</script>

<style></style>
